export { AbsenceGeneralForm } from "./absence-general-form";
